<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">

    <div class="entity-config-shell d-flex flex-column gap-4 gap-lg-3 mx-auto mt-4">

        <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
            <div class="entity-config-top-hero px-2 px-md-3 py-3">
                <div class="row g-2 align-items-start flex-nowrap">
                    <div class="col">
                        <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">
                            Notifications
                        </h1>

                        <p class="entity-page-subtitle text-white mb-0">
                            Define what triggers it, who hears about it, and how.
                        </p>
                    </div>
                </div>
            </div>
        </section>
        </div>
      </div>
     <div class="container-fluid mt-4">
        <div class="d-flex-1  mb-1" >
          <notification-stepper
                :active-step="active_step"
                @update-step="active_step = $event">
            </notification-stepper>
        </div>

</div>
<div v-show="active_step === 1">
    <div class="row g-4 mt-2">
        <div class="col-lg-12">
            <div class="card border-0 shadow-sm rounded-4">
                <div class="card-body p-4">
                    <small class="text-uppercase fw-bold text-primary">
                        Step 1
                    </small>
                    <h3 class="fw-bold mt-2 mb-1">
                        General Information
                    </h3>
                    <p class="text-secondary mb-4">
                        Give your notification a meaningful name and configure its default settings.
                    </p>
                    <div class="row g-4">
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">
                                Notification Name
                                <span class="text-danger">*</span>
                            </label>
                            <input
                                class="form-control"
                                type="text"
                                placeholder="Enter notification name"
                                v-model="notification.name">
                            <small
                                class="text-danger"
                                v-if="errors.name">
                                {{ errors.name }}
                            </small>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">
                                Priority
                                <span class="text-danger">*</span>
                            </label>
                           <select
                                class="form-select"
                                v-model="notification.priority">

                                <option value="">
                                    Select Priority
                                </option>

                                <option
                                    v-for="priority in priority_options"
                                    :key="priority.value"
                                    :value="priority.value">

                                    {{ priority.label }}

                                </option>

                            </select>
                        </div>
                        <div class="col-12">
                            <label class="form-label fw-semibold">
                                Description
                            </label>
                            <textarea
                                class="form-control"
                                rows="5"
                                maxlength="500"
                                placeholder="Describe this notification..."
                                v-model="notification.description">
                            </textarea>
                            <div
                                class="text-end text-muted small mt-1">
                                {{ notification.description.length }}/500
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="card bg-light border-0 rounded-4">
                                <div class="card-body">
                                 <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 class="fw-bold mb-1">
                                                Notification Status
                                            </h6>
                                            <small class="text-muted">

                                                Active notifications will be
                                                processed by the Notification
                                                Engine.

                                                Inactive notifications are
                                                archived and will not generate
                                                notifications until activated.
                                            </small>
                                        </div>
                                        <div>
                                            <div class="form-check form-switch">
                                                <input
                                                    class="form-check-input fs-4"
                                                    type="checkbox"
                                                    v-model="notification.is_active">
                                            </div>
                                           
           
                            </div>
                            
           
                        </div>
                       
                        </div>
                    </div>
                    <div class="d-flex justify-content-end align-items-center mt-4">
                        <button
                            class="btn btn-success mt-3 gap-3 ms-3 "
                            @click="create_notification_rule"
                            :disabled="loading">
                            <span
                                v-if="loading"
                                class="spinner-border spinner-border-sm mt-3">
                            </span>
                            <i
                                v-else
                                class="bi bi-check-circle mt-3">
                            </i>
            Save Notification
        </button> 
        <button
            class="btn btn-primary px-4 mt-3 ms-3"
            @click="nextStep">

            Next

            <i class="bi bi-arrow-right mt-3"></i>

            </button>
                    </div>
                    </div>
                </div>

            </div>
</div>
</div>
</div>
</div>
                                                                     
<div v-show="active_step === 2">
    <div class="row g-4 mt-2">
        <div class="col-lg-12">
            <div class="card border-0 shadow-sm rounded-4">
                <div class="card-body p-4">
                    <small class="text-uppercase fw-bold text-primary">
                        Step 2
                    </small>
                    <h3 class="fw-bold mt-2">
                        Configure Trigger
                    </h3>
                    <p class="text-secondary mb-4">
                        Choose the event that should cause this notification to be generated.
                    </p>
                    <div class="row g-4">
                        <div class="col-md-6">

    <label class="form-label fw-semibold">
        Event Trigger
        <span class="text-danger">*</span>
    </label>

    <select
        class="form-select"
        v-model="notification.event_trigger">
        <option value="">
            Select Event Trigger
        </option>
        <option
            v-for="trigger in event_trigger_options"
            :key="trigger.value"
            :value="trigger.value">

            {{ trigger.label }}
        </option>
    </select>
</div>
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">
                                Event Type
                                <span class="text-danger">*</span>
                            </label>
                            <select
                                class="form-select"
                                v-model="notification.event_type">
                                <option value="">
                                    Select Event Type
                                </option>
                                <option
                                    v-for="event in event_types"
                                    :key="event.id"
                                    :value="event.id">
                                    {{ event.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

 <div class="card border-0 shadow-sm rounded-4 mt-4">
        <div class="card-body p-4">
            <div class="d-flex justify-content-between align-items-center mb-3">
             <div>
                    <h4 class="fw-bold mb-1">
                        Conditions
                    </h4>
                    <small class="text-muted">

                        Add optional filters to control when this notification
                        should execute.

                    </small>
                </div>
                <button
                    class="btn btn-primary"
                    @click="add_condition">
                    <i class="bi bi-plus-circle me-2"></i>
                    Add Condition
                </button>
            </div>
            <div
                v-if="conditions.length === 0"
                class="text-center py-5">
                <i class="bi bi-funnel display-4 text-secondary"></i>
                <p class="text-muted mt-3">
                    No conditions added.
                </p>
            </div>
            <div
                v-for="(condition,index) in conditions"
                :key="index"
                class="card border rounded-3 mb-3">
                <div class="card-body">
                    <div class="row g-3">
                        <div class="col-md-3">

                            <label class="form-label">
                                Field
                            </label>
                            <select
                                class="form-select"
                                v-model="condition.field">
                                <option value="">

                                    Select Field

                                </option>
                                <option
                                    v-for="field in condition_fields"
                                    :key="field.id"
                                    :value="field.id">

                                    {{ field.name }}
                                </option>
                            </select>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label">
                                Operator
                            </label>
                            <select
                                class="form-select"
                                v-model="condition.operator">

                                <option>equals</option>

                                <option>not equals</option>

                                <option>contains</option>

                                <option>starts with</option>

                                <option>ends with</option>

                                <option>greater than</option>

                                <option>less than</option>
                            </select>
                        </div>
                        <div class="col-md-5">
                            <label class="form-label">
                                Value
                            </label>
                            <input
                                class="form-control"
                                type="text"
                                placeholder="Enter comparison value"
                                v-model="condition.value">

                        </div>
                        <div class="col-md-1 d-flex align-items-end">
                            <button
                                class="btn btn-outline-danger w-100"
                                @click="remove_condition(index)">
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                  </div>
                </div>
            </div>

        </div>
    </div>
    <div class="card border-0 shadow-sm rounded-4 mt-4">
        <div class="card-body">
            <h5 class="fw-bold mb-3">
                Trigger Preview
            </h5>
            <div class="alert alert-light border">
                <strong>
                    When
                </strong>
                {{ selected_event_trigger_name || "Event trigger" }}
                →
                {{ selected_event_type_name || "Event Type" }}
                <span v-if="conditions.length">
                    with
                    {{ conditions.length }}
                    condition(s)
                </span>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-between mt-4">
        <button
            class="btn btn-outline-secondary"
            @click="active_step = 1">
            <i class="bi bi-arrow-left me-2"></i>
            Back
        </button>
        <button
            class="btn btn-primary"
            @click="active_step = 3">
            Next
            <i class="bi bi-arrow-right ms-2"></i>
        </button>
    </div>
</div>

<div v-show="active_step === 3">
    <div class="row g-4 mt-2">
        <div class="col-lg-12">
            <div class="card border-0 shadow-sm rounded-4">
                <div class="card-body p-4">
                    <small class="text-uppercase fw-bold text-primary">
                        Step 3
                    </small>
                    <h3 class="fw-bold mt-2">
                        Notification Recipients
                    </h3>
                    <p class="text-secondary mb-4">
                        Choose who should receive this notification. You can
                        add multiple recipient groups.
                    </p>
                    <div
                        v-for="(recipient,index) in recipient_groups"
                        :key="index"
                        class="card border rounded-4 mb-4">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-4">
                                <h5 class="fw-bold mb-0">
                                    Recipient Group {{ index + 1 }}
                                </h5>
                                <button
                                    class="btn btn-outline-danger btn-sm"
                                    @click="remove_recipient(index)"
                                    v-if="recipient_groups.length > 1">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                            <div class="row g-4">

                                <div class="col-md-4">
                                    <label class="form-label fw-semibold">
                                        Recipient Type
                                    </label>
                                    <select
                                        class="form-select"
                                        v-model="recipient.type">

                                        <option value="">
                                            Select Type
                                        </option>

                                        <option value="role">
                                            Role
                                        </option>

                                        <option value="specific_user">
                                            Specific User
                                        </option>

                                        <option value="dynamic">
                                            Dynamic User
                                        </option>
                                    </select>
                                </div>
                                <div
                                    class="col-md-4"
                                    v-if="recipient.type === 'role'">

                                    <label class="form-label fw-semibold">
                                        Select Role
                                    </label>
                                    <select
                                        class="form-select"
                                        v-model="recipient.role">

                                        <option value="">
                                            Choose Role
                                        </option>
                                        <option
                                            v-for="role in roles"
                                            :key="role.id"
                                            :value="role.id">

                                            {{ role.name }}
                                        </option>
                                    </select>
                                </div>
                                <div
                                    class="col-md-4"
                                    v-if="recipient.type === 'specific_user'">
                                    <label class="form-label fw-semibold">
                                        Select User
                                    </label>
                                    <select
                                        class="form-select"
                                        v-model="recipient.user">
                                        <option value="">
                                            Choose User
                                        </option>
                                        <option
                                            v-for="user in users"
                                            :key="user.id"
                                            :value="user.id">
                                            {{ user.full_name }}
                                        </option>
                                    </select>
                                </div>
                                <div
                                    class="col-md-4"
                                    v-if="recipient.type === 'dynamic'">

                                    <label class="form-label fw-semibold">

                                        Dynamic Recipient

                                    </label>

                                    <select
                                        class="form-select"
                                        v-model="recipient.dynamic">

                                        <option value="">
                                            Choose Dynamic Recipient
                                        </option>

                                        <option value="entity_owner">
                                            Entity Owner
                                        </option>

                                        <option value="assigned_user">
                                            Assigned User
                                        </option>

                                        <option value="created_by">
                                            Created By
                                        </option>

                                        <option value="updated_by">
                                            Last Updated By
                                        </option>

                                        <option value="manager">
                                            Manager
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-2">

                                    <label class="form-label fw-semibold">

                                    CC
                                    </label>
                                    <div class="form-check form-switch mt-2">

                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            v-model="recipient.cc">

                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <label class="form-label fw-semibold">
                                        Required
                                    </label>
                                    <div class="form-check form-switch mt-2">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            v-model="recipient.required">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        class="btn btn-outline-primary"
                        @click="add_recipient_group">
                        <i class="bi bi-plus-circle me-2"></i>
                        Add Recipient Group
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="card border-0 shadow-sm rounded-4 mt-4">
        <div class="card-body">
            <h5 class="fw-bold mb-3">
                Recipient Summary
            </h5>
            <div
                v-if="recipient_groups.length === 0"
                class="text-muted">
                No recipients selected.
            </div>
            <div
                v-for="(recipient,index) in recipient_groups"
                :key="'summary'+index"
                class="border rounded-3 p-3 mb-2">
                <strong>
                    Group {{ index+1 }}
                </strong>
                <br>
                Type:
                <span class="badge bg-primary">
                    {{ recipient.type || 'Not Selected' }}
                </span>
            <span
                    class="ms-3"
                    v-if="recipient.cc">
                 CC
                </span>
                <span
                    class="ms-3"
                    v-if="recipient.required">
                    Required
                </span>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-between mt-4">
        <button
            class="btn btn-outline-secondary"
            @click="active_step = 2">
            <i class="bi bi-arrow-left me-2"></i>
            Back
        </button>
        <button
            class="btn btn-primary"
            @click="active_step = 4">
            Next
            <i class="bi bi-arrow-right ms-2"></i>
        </button>
    </div>
</div>
<div v-show="active_step === 4">
    <div class="row g-4 mt-2">
    <div class="col-lg-12">
            <div class="card border-0 shadow-sm rounded-4">
                <div class="card-body p-4">
                    <small class="text-uppercase fw-bold text-primary">
                        Step 4
                    </small>
                    <h3 class="fw-bold mt-2">
                        Delivery Channels
                    </h3>
                    <p class="text-secondary mb-4">
                        Select one or more channels that will deliver this notification.
                    </p>
                    <div class="row g-4">
                        <div class="col-md-3">
                            <label class="channel-card p-4 text-center w-100">
                                <input
                                    class="form-check-input channel-check"
                                    type="checkbox"
                                    value="email"
                                    v-model="selected_channels">
                                <div class="mt-3">
                                    <i class="bi bi-envelope-fill display-5 text-primary"></i>
                                    <h5 class="mt-3">
                                        Email
                                    </h5>
                                 <small class="text-muted">
                                      Send email notifications.
                                    </small>
                                </div>
                            </label>
                        </div>
                        <div class="col-md-3">
                            <label class="channel-card p-4 text-center w-100">
                                <input
                                    class="form-check-input channel-check"
                                    type="checkbox"
                                    value="in_app"
                                    v-model="selected_channels">
                                <div class="mt-3">
                                 <i class="bi bi-bell-fill display-5 text-success"></i>
                                    <h5 class="mt-3">
                                        In-App
                                    </h5>
                                    <small class="text-muted">
                                        Notification Center.
                                 </small>
                                </div>
                            </label>
                        </div>
                        <div class="col-md-3">

                            <label class="channel-card p-4 text-center w-100">
                                <input
                                    class="form-check-input channel-check"
                                    type="checkbox"
                                    value="sms"
                                    v-model="selected_channels">
                                <div class="mt-3">
                                    <i class="bi bi-chat-dots-fill display-5 text-warning"></i>
                                    <h5 class="mt-3">
                                        SMS
                                    </h5>
                                    <small class="text-muted">
                                        Send text message.
                                    </small>
                                </div>
                            </label>
                        </div>
                        <div class="col-md-3">
                            <label class="channel-card p-4 text-center w-100">
                                <input
                                    class="form-check-input channel-check"
                                    type="checkbox"
                                    value="webhook"
                                    v-model="selected_channels">
                                <div class="mt-3">
                                    <i class="bi bi-globe display-5 text-info"></i>
                                    <h5 class="mt-3">
                                        Webhook
                                    </h5>
                                    <small class="text-muted">
                                        Send to external systems.
                                    </small>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
        class="card shadow-sm border-0 rounded-4 mt-4"
        v-if="selected_channels.includes('email')">
        <div class="card-body">
            <h5 class="fw-bold">
                Email Configuration
            </h5>
            <div class="row g-4">
                <div class="col-md-6">
                    <label class="form-label">
                        Subject
                    </label>
                    <input
                        class="form-control"
                       v-model="email_subject">
                </div>
                <div class="col-md-6">
                    <label class="form-label">
                        Priority
                    </label>
                    <select
                        class="form-select"
                        v-model="email_priority">
                    </select>
                     <div class="mb-3">
                        
            </div>
            
        </div>
    </div>
    <div
    class="card shadow-sm border-0 rounded-4 mt-4"
    v-if="selected_channels.includes('email')">            
        <div class="card-body">
            <textarea
                rows="4"
                class="form-control"
                placeholder="Email message..."
                v-model="sms_message">
            </textarea>
        </div>
            </div>
        </div>
    </div>


    <div
        class="card shadow-sm border-0 rounded-4 mt-4"
        v-if="selected_channels.includes('sms')">

        <div class="card-body">
            <textarea
                rows="4"
                class="form-control"
                placeholder="SMS message..."
                v-model="sms_message">
            </textarea>
        </div>
    </div>
    <div
        class="card shadow-sm border-0 rounded-4 mt-4"
        v-if="selected_channels.includes('webhook')">
        <div class="card-body">
            <label class="form-label">
                Endpoint URL
            </label>
            <input
                class="form-control"
                v-model="webhook_url">
        </div>
    </div>
    <div class="card border-0 shadow-sm rounded-4 mt-4">
        <div class="card-body">
            <h5 class="fw-bold">
                Selected Delivery Channels
            </h5>
            <div v-if="selected_channels.length">
                <span
                    v-for="channel in selected_channels"
                    :key="channel"
                    class="badge bg-primary me-2">
                    {{ channel }}
                </span>
            </div>
            <div
                v-else
                class="text-muted">
                No delivery channel selected.
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
        <button
            class="btn btn-outline-secondary"
            @click="active_step = 3">
            <i class="bi bi-arrow-left me-2"></i>
            Back
        </button>
        <button
            class="btn btn-primary"
            @click="active_step = 5">
            Next
            <i class="bi bi-arrow-right ms-2"></i>
        </button>
    </div>
</div>
<div v-show="active_step === 5">
    <div class="card border-0 shadow-sm rounded-4">
        <div class="card-body p-4">

            <h3 class="fw-bold">
                Scope & Review
            </h3>
            <p class="text-muted mb-4">
                Assign this notification to one or more Entity Configurations and review everything before creating it.
            </p>
            <div class="mb-4">
                <h5 class="fw-bold mb-3">
                    Entity Configuration Assignment
                </h5>
                <label class="form-label fw-semibold">
                    Entity Type
                </label>
                <select
                    class="form-select mb-3"
                    v-model="selected_entity_type">
                    <option value="">
                        Select Entity Type
                    </option>
                    <option
                        v-for="entity in entity_types"
                        :key="entity.id"
                        :value="entity.id">
                        {{ entity.name }}
                    </option>
                </select>
                <label class="form-label fw-semibold">
                    Entity Configurations
                </label>
                <div
                    class="border rounded-3 p-3"
                    style="max-height:220px; overflow-y:auto;">
                    <div
                        class="form-check mb-2"
                        v-for="config in entity_configs"
                        :key="config.id">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            :value="config.id"
                            v-model="selected_entity_configs">
                        <label class="form-check-label">
                            {{ config.name }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="card border rounded-3 mb-4">
                <div class="card-body">
                    <h5 class="fw-bold">
                        Notification Status
                    </h5>
                    <div class="form-check form-switch mt-3">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="notification.is_active">
                        <label class="form-check-label">
                            {{ notification.is_active ? "Active" : "Inactive" }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="card border rounded-3">
                <div class="card-header bg-light">
                    <strong>
                        Review Summary
                  </strong>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label class="text-muted">
                                Notification Name
                            </label>
                            <p>{{ notification.name }}</p>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="text-muted">
                                Priority
                            </label>
                            <p>{{ notification.priority }}</p>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="text-muted">
                                Trigger
                            </label>
                            <p>{{ notification.event_trigger }}</p>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="text-muted">
                                Channels
                            </label>
                            <div>
                                <span
                                    class="badge bg-primary me-2"
                                    v-for="channel in selected_channels"
                                    :key="channel">
                                   {{ channel }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <h6 class="fw-bold">
                        Recipient Groups
                    </h6>
                    <div
                        v-for="(recipient,index) in recipient_groups"
                        :key="index"
                        class="border rounded-3 p-3 mb-2">
                        <strong>
                            Recipient {{ index + 1 }}
                        </strong>
                       <br>
                        Type:
                        {{ recipient.type || recipient.role_type }}
                        <br>
                        Role:
                        {{ recipient.role_name }}
                    </div>
                    <hr>
                    <h6 class="fw-bold">
                        Assigned Entity Configurations
                    </h6>
                    <p>
                        {{ selected_entity_configs.length }}
                        configuration(s) selected.
                    </p>
                    <hr>
                    <h6 class="fw-bold">
                        Status
                    </h6>
                    <span
                        class="badge"
                        :class="notification.is_active ? 'bg-success' : 'bg-secondary'">
                        {{ notification.is_active ? "Active" : "Inactive" }}
                    </span>
                </div>
            </div>
            <div class="d-flex justify-content-between mt-4">
                <button
                    class="btn btn-success"
                    @click="create_notification_rule">
                    <i class="bi bi-check-circle"></i>
                    Create Notification
                </button>
            </div>
        </div>
    </div>
</div>

